import * as actionTypes from "../actionTypes";

export const getEcommerceCategory = payload => ({
    type: actionTypes.GET_ECOMMERCE_CATEGORY,
    payload
})

export const setEcommerceCategory = payload => ({
    type: actionTypes.SET_ECOMMERCE_CATEGORY,
    payload
})

export const createEcommerceCategory = payload => ({
    type: actionTypes.CREATE_ECOMMERCE_CATEGORY,
    payload
})

export const updateEcommerceCategory = payload => ({
    type: actionTypes.UPDATE_ECOMMERCE_CATEGORY,
    payload
})

export const deleteEcommerceCategory = payload => ({
    type: actionTypes.DELETE_ECOMMERCE_CATEGORY,
    payload
})

export const changeEcommerceCategoryStatus = payload => ({
    type: actionTypes.CHANGE_ECOMMERCE_CATEGORY_STATUS,
    payload
})

export const getEcommerceSubCategoryByCategoryId = payload => ({
    type: actionTypes.GET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID,
    payload
})

export const setEcommerceSubCategoryByCategoryId = payload => ({
    type: actionTypes.SET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID,
    payload
})

export const getEcommerceSubCategory = payload => ({
    type: actionTypes.GET_ECOMMERCE_SUB_CATEGORY,
    payload
})

export const setEcommerceSubCategory = payload => ({
    type: actionTypes.SET_ECOMMERCE_SUB_CATEGORY,
    payload
})

export const createEcommerceSubCategory = payload => ({
    type: actionTypes.CREATE_ECOMMERCE_SUB_CATEGORY,
    payload
})

export const updateEcommerceSubCategory = payload => ({
    type: actionTypes.UPDATE_ECOMMERCE_SUB_CATEGORY,
    payload
})

export const deleteEcommerceSubCategory = payload => ({
    type: actionTypes.DELETE_ECOMMERCE_SUB_CATEGORY,
    payload
})

export const changeEcommercesubCategoryStatus = payload => ({
    type: actionTypes.CHANGE_ECOMMERCE_SUB_CATEGORY_STATUS,
    payload
})

export const getEcommerceAttribute = payload => ({
    type: actionTypes.GET_ECOMMERCE_ATTRIBUTE,
    payload
})

export const setEcommerceAttribute = payload => ({
    type: actionTypes.SET_ECOMMERCE_ATTRIBUTE,
    payload
})

export const createEcommerceAttribute = payload => ({
    type: actionTypes.CREATE_ECOMMERCE_ATTRIBUTE,
    payload
})

export const updateEcommerceAttribute = payload => ({
    type: actionTypes.UPDATE_ECOMMERCE_ATTRIBUTE,
    payload
})

export const deleteEcommerceAttribute = payload => ({
    type: actionTypes.DELETE_ECOMMERCE_ATTRIBUTE,
    payload
})

export const changeEcommerceAttributeStatus = payload => ({
    type: actionTypes.CHANGE_ECOMMERCE_ATTRIBUTE_STATUS,
    payload
})

export const getEcommerceProduct = payload => ({
    type: actionTypes.GET_ECOMMERCE_PRODUCT,
    payload
})

export const setEcommerceProduct = payload => ({
    type: actionTypes.SET_ECOMMERCE_PRODUCT,
    payload
})

export const createEcommerceProduct = payload => ({
    type: actionTypes.CREATE_ECOMMERCE_PRODUCT,
    payload
})

export const updateEcommerceProduct = payload => ({
    type: actionTypes.UPDATE_ECOMMERCE_PRODUCT,
    payload
})

export const deleteEcommerceProduct = payload => ({
    type: actionTypes.DELETE_ECOMMERCE_PRODUCT,
    payload
})

export const changeEcommerceProductStatus = payload => ({
    type: actionTypes.CHANGE_ECOMMERCE_PRODUCT_STATUS,
    payload
})